module.exports = __webpack_public_path__ + "static/media/hotdog.c905c19d.svg";